<script setup lang="ts">

const {
  modelValue,
  disabled = false,
} = defineProps<{
  modelValue: boolean,
  disabled?: boolean
}>()

const emit = defineEmits(['update:modelValue'])
function toggleValue() {
  if (disabled) {
    return
  }
  emit('update:modelValue', !modelValue)
}
</script>

<template>
  <div class="wad4-switch" :class="{'wad4-switch--disabled': disabled}" tabindex="0" role="switch"
       @pointerup="toggleValue"
       @keydown.space.prevent="toggleValue"
       @keydown.enter.prevent="toggleValue"
       :aria-checked="modelValue"
       :aria-disabled="disabled"
  >
    <div class="wad4-switch__bar" :class="{'wad4-switch__bar--active': modelValue}"/>
    <div class="wad4-switch__thumb" :class="{'wad4-switch__thumb--active': modelValue}"/>
  </div>
</template>

<style lang="scss">
.wad4-switch {
  width: 40px;
  height: 20px;
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
  flex-grow: 0;

  &--disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &__bar {
    position: absolute;
    left: 0;
    top: 15%;
    width: 100%;
    height: 70%;
    border-radius: 7px;
    opacity: 0.5;
    background: $wad4-c-foreground-fg-tertiary;

    &--active {
      background-color: $wad4-c-foreground-fg-brand-solid;
    }
  }

  &__thumb {
    position: absolute;
    left: 0;
    top: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color:$wad4-c-foreground-fg-subtle;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    transition: .4s cubic-bezier(.25,.8,.25,1);

    &--active {
      transform: translate3d(20px, 0, 0);
      background-color: $wad4-c-foreground-fg-brand-solid;
    }
  }

}
</style>
